<template>

    <v-form class="form-login" :data-testid="$options.name + '__form'">

        <div class="form-login__fieldset">

            <v-select
                v-model="method"
                :data-testid="$options.name + '__select-field' + '__method'"
                :items="$store.getters.getAuthNails.methods"
                :label="$t('authorization method')"
                prepend-inner-icon="assignment_turned_in"
                hide-details
                color="primary"
                rows="1"
                height="36"
              >
            </v-select>

            <v-text-field
              :data-testid="$options.name + '__text-field__' + 'login'"
              color="primary"
              ref="login"
              @keyup.enter="submit"
              :label="$t('login')"
              hide-details
              v-model="login"
              required
              class="text-button"
            ></v-text-field>

            <v-text-field
              :data-testid="$options.name + '__text-field__' + 'password'"
              color="primary"
              ref="password"
              @keyup.enter="submit"
              @click:append="() => (visible = !visible)"
              :label="$t('password')"
              hide-details
              :append-icon="visible ? 'visibility' : 'visibility_off'"
              :type="visible ? 'text' : 'password'"
              v-model="password"
              required
            ></v-text-field>
           
        </div>

        <v-btn block round outline class="line form-login__submit text-uppercase"
          @click="submit" 
          :disabled="method == 'nms' ? (!login || !password) : false" 
          :data-testid="$options.name + '__btn__' + 'password'"
        >
          {{$t('enter')}}
        </v-btn>

        <span v-if="!submitStatus">{{$getTranslate(message)}}</span>

    </v-form>

</template>

<script lang="ts">
import Vue from 'vue'
import { mapGetters } from 'vuex'

// Типы
interface UserData {
  login: string
  password: string
  subsystem: string
  method: string
}

interface ComponentData {
  visible: boolean
  submitStatus: boolean
  message: string
  method: string
  login: string
  password: string
  subsystem: string
  users: any[]
}

export default Vue.extend({
  name: 'FORM_LOGIN',

  computed: {
    ...mapGetters(['getModules']),
  },

  watch: {
    getModules: {
      handler(newVal: string[]): void {
        if (newVal?.length) {
          this.subsystem = newVal[0]
        }
      },
      deep: true
    },
  },

  data(): ComponentData {
    return {
      visible: false,
      submitStatus: true,
      message: 'wrong login/password',
      method: 'nms',
      login: 'admin',
      password: 'admin',
      // password: 'enodemon-admin',
      subsystem: 'common',
      users: []
    }
  },

  created(): void {
    this.setup()
  },

  mounted(): void {
    this.focus()
  },

  methods: {
    setup(): void {
      const savedAuthorizedMethod = localStorage.getItem('AuthMethod')
      if (savedAuthorizedMethod === 'LDAP' || savedAuthorizedMethod === 'nms') {
        this.method = savedAuthorizedMethod
      }
    },

    submit(): void {
      this.submitStatus = true

      const user: UserData = {
        login: this.login,
        password: this.password,
        subsystem: this.subsystem,
        method: this.method
      }

      if (this.method === 'nms') {
        this.$emit('logIn', user)
      }

      if (this.method === 'keycloak') {
        this.$emit('KCLogIn', user)
      }

      if (this.method === 'LDAP') {
        this.submitStatus = true
        const ldapUser: UserData = {
          login: this.login,
          password: this.password,
          subsystem: this.subsystem,
          method: this.method
        }
        this.$emit('ADLogIn', ldapUser)
      }

      localStorage.setItem('AuthMethod', this.method)
    },

    focus(field: string = 'login'): this {
      const inputRef = this.$refs[field] as HTMLElement
      setTimeout(() => inputRef?.focus(), 10)
      return this
    },

    reset(): void {
      this.submitStatus = false
      this.login = ''
      this.password = ''
    },
  },
})
</script>

<style lang="stylus">

    .form-login__fieldset

        width: 100%
        margin-bottom: 24px

    .form-login__field

    .form-login__submit

        text-transform: none
        font-weight: 100
        letter-spacing: 1px
        width: 100%

</style>
